<template>
  <div v-if="init === 1">
    <slot></slot>
  </div>
  <loader v-else :card="card" :height="height" :init="doReload" :loadText="loadText" :errorText="errorText" :retryText="retryText" :loading="init === 0" :errorMsgs="err"></loader>
</template>

<script>
import { extractFullMessages } from '@/utils/extract'
import Loader from './Loader'
export default {
  data() {
    return {
      init: 0,
      err: []
    }
  },
  methods: {
    doInit() {
      // Init variables
      this.init = 0
      this.err = []
      const loadResult = this.load()
      // Do note that the common use case is to pass in async function
      // the async function must throw the error in order to receive it here
      loadResult
        .then(result => {
          this.init = 1
        })
        .catch(err => {
          this.err = extractFullMessages(err)
          this.init = 2
        })
    },
    doReload() {
      this.doInit()
    }
  },
  mounted() {
    this.doInit()
  },
  components: {
    Loader
  },
  props: {
    card: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 400
    },
    load: {
      // Need pass in a promise or async fucntion (which returns a promise)
      type: Function,
      default: function () {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve()
          }, 1000)
        })
      }
    },
    loadText: {
      type: String,
      default: 'Loading...'
    },
    errorText: {
      type: String,
      default: 'Failed to load the required resource'
    },
    retryText: {
      type: String,
      default: 'Retry'
    }
  }
}
</script>

<style lang="scss">
</style>
